var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRecord = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff0e00",
    fillRule: "evenodd",
    d: "M6.381.157c3.226 0 5.842 2.616 5.842 5.843 0 3.226-2.616 5.842-5.842 5.842C3.154 11.842.538 9.226.538 6 .538 2.773 3.154.157 6.381.157z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRecord, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/record.3d46e2a5.svg";
export { ForwardRef as ReactComponent };